import axios, { AxiosError } from 'axios';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { captureException } from '@sentry/browser';
import { setErrorObject } from '../../store/globalErrors/reducer';
import { ErrorResource } from '../../types/error';
import {
  GENERIC_ERROR_MESSAGE,
  extractErrorMessage,
} from './extractErrorMessage';

interface HandleErrorObjectProps {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  error: AxiosError<unknown, any>;
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>;
  errorResource: ErrorResource;
}

export function handleErrorObject({
  error,
  dispatch,
  errorResource,
}: HandleErrorObjectProps) {
  const { response } = error;
  const code = error?.status || response?.status;
  let message = extractErrorMessage(response?.data) ?? GENERIC_ERROR_MESSAGE;

  if (axios.isAxiosError(error)) {
    const contentType = error.response?.headers['content-type'];
    if (typeof contentType === 'string' && contentType.includes('text/html')) {
      message = GENERIC_ERROR_MESSAGE;
    }
  }

  console.error('error:', error);

  dispatch(setErrorObject({ code, message, errorResource }));
  captureException(error);
}
